import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 2BEF3471-36F9-4813-AC45-3C3FF9FC329C
 * name vanish-quarter
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/vanish-quarter.svg
 * tags
 */
export const VanishQuarterIcon = createSvgIcon(<><path d="M11 3H13V8H11V3M4.9 6.3L6.3 4.9L9.1 7.7L7.8 9.2L4.9 6.3M8 13H3V11H8V13" /></>, 'VanishQuarterIcon');
export default VanishQuarterIcon